/* tslint:disable */
/* eslint-disable */
/**
 * Notes API
 * API for managing notes with tags, mentions and attachments
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Attachment associated with a note
 * @export
 * @interface AttachmentDto
 */
export interface AttachmentDto {
    /**
     * Unique identifier of the attachment
     * @type {string}
     * @memberof AttachmentDto
     */
    id?: string;
    /**
     * ID of the stored file for download
     * @type {string}
     * @memberof AttachmentDto
     */
    storedFileId?: string;
    /**
     * File name of the attachment
     * @type {string}
     * @memberof AttachmentDto
     */
    name?: string;
    /**
     * File extension
     * @type {string}
     * @memberof AttachmentDto
     */
    extension?: string;
    /**
     * File size in bytes
     * @type {number}
     * @memberof AttachmentDto
     */
    size?: number;
}

/**
 * Check if a given object implements the AttachmentDto interface.
 */
export function instanceOfAttachmentDto(value: object): value is AttachmentDto {
    return true;
}

export function AttachmentDtoFromJSON(json: any): AttachmentDto {
    return AttachmentDtoFromJSONTyped(json, false);
}

export function AttachmentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AttachmentDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'storedFileId': json['storedFileId'] == null ? undefined : json['storedFileId'],
        'name': json['name'] == null ? undefined : json['name'],
        'extension': json['extension'] == null ? undefined : json['extension'],
        'size': json['size'] == null ? undefined : json['size'],
    };
}

export function AttachmentDtoToJSON(json: any): AttachmentDto {
    return AttachmentDtoToJSONTyped(json, false);
}

export function AttachmentDtoToJSONTyped(value?: AttachmentDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'storedFileId': value['storedFileId'],
        'name': value['name'],
        'extension': value['extension'],
        'size': value['size'],
    };
}

